export const productForms =
  "Forms of the requested compound with the same structure but different salt parts. They are great replacements, providing the same reaction products.";
export const inStockEquivalents =
  "Other compounds that furnish the same product and are equivalents in synthesis. However, they can require adjustment of the reaction conditions.";
export const productAnalogs =
  "Similar products that can be used in the same reaction and provide end-compounds with improved properties.";
